<template>
    <div class="full-width-overflow">
        <div class="container-xl advantage-block">
            <div class="col-lg-6">
                <BlockTitle :title="contentPages.title" class="text-lg-start two-row-title" />
            </div>
            <div class="d-flex flex-row advantage-block-content">
                <div class="col-lg-5 col-md-12 align-items-center relative-position container-image-advantage">
                    <img src="/images/delivery.png" alt="delivery" class="image-advantage" />
                </div>
                <div class="col-lg-7 col-md-12">
                    <div class="advantages-block-list justify-content-lg-start">
                        <AdvantageBlock v-for="(item, index) in contentPages.element" :key="index" :item="item" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import BlockTitle from '~/pages/index/components/BlockTitle.vue';
import AdvantageBlock from '~/pages/index/components/AdvantageBlock.vue';

defineProps<{ contentPages: { title: string; element: { icon: string; title: string }[] } }>();
</script>

<style lang="scss" scoped>
.full-width-overflow {
    overflow: hidden;
}
.advantage-block {
    margin-top: 12.56rem;
    width: 100%;
}
.relative-position {
    position: relative;
}
.image-advantage {
    flex-shrink: 0;
    position: absolute;
    right: 0;
}
.advantage-block-content {
    gap: 3rem;
    margin-top: 1.88rem;
}
.advantages-block-list {
    display: flex;
    justify-content: center;
    gap: 24px 40px;
    flex-wrap: wrap;
    flex: 1 0 50%; /* explanation below */
}

.container-image-advantage{
    display: flex;
}

@media (max-width: 1279px) {

    .advantage-block-content{
        justify-content: center;
    }

    .container-image-advantage{
        display: none;
    }

}

@media (max-width: 1000px) {
    .advantage-block{
        margin-top: 106px;
    }
}


@media (max-width: 768px) {
    .advantage-block{
        margin-top: 80px;
    }

    .advantage-block-content {
        margin-top: 24px;
    }

    .advantages-block-list  {
        flex-direction: column ;
        gap: 24px 40px;
        flex-wrap: nowrap;
    }
}


@media (max-width: 480px) {
    .advantage-block{
        margin-top: 40px;
    }
}
</style>
